var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResiduals(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6C24.8807 6 26 4.88071 26 3.5C26 2.11929 24.8807 1 23.5 1C22.1193 1 21 2.11929 21 3.5C21 4.88071 22.1193 6 23.5 6Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 26C4.88071 26 6 24.8807 6 23.5C6 22.1193 4.88071 21 3.5 21C2.11929 21 1 22.1193 1 23.5C1 24.8807 2.11929 26 3.5 26Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5454 28.5078C27.2023 28.5078 28.5454 27.1647 28.5454 25.5078C28.5454 23.851 27.2023 22.5078 25.5454 22.5078C23.8886 22.5078 22.5454 23.851 22.5454 25.5078C22.5454 27.1647 23.8886 28.5078 25.5454 28.5078Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.5C4.60457 6.5 5.5 5.60456 5.5 4.49999C5.5 3.39542 4.60457 2.5 3.5 2.5C2.39543 2.5 1.5 3.39542 1.5 4.49999C1.5 5.60456 2.39543 6.5 3.5 6.5Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21C17.6421 21 21 17.6421 21 13.5C21 9.35786 17.6421 6 13.5 6C9.35786 6 6 9.35786 6 13.5C6 17.6421 9.35786 21 13.5 21Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25244 20.7476L6.75244 20.2476L7.25244 19.7476",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8198 7.34961L20.8198 6.34961",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73145 6.88916L6.25067 7.36916L6.7699 7.84917",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L22 22",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.345 17.999V16.8919C12.725 16.881 12.0836 16.6837 11.7095 16.4096L11.966 15.6753C12.3509 15.9383 12.9068 16.1466 13.5054 16.1466C14.2644 16.1466 14.7775 15.6972 14.7775 15.0724C14.7775 14.4696 14.3606 14.0969 13.5695 13.768C12.4792 13.3296 11.8057 12.8254 11.8057 11.8718C11.8057 10.962 12.4364 10.2715 13.4208 10.1071V9H14.0836V10.0632C14.725 10.0851 15.1633 10.2605 15.4743 10.4469L15.207 11.1703C14.9826 11.0388 14.5443 10.7976 13.8601 10.7976C13.037 10.7976 12.727 11.3018 12.727 11.7403C12.727 12.3102 13.1225 12.5952 14.0525 12.9898C15.1536 13.4502 15.7095 14.0202 15.7095 14.9957C15.7095 15.8616 15.1215 16.6727 14.0205 16.8591V18H13.345V17.999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResiduals);
export default __webpack_public_path__ + "static/media/residuals.74610831a3ba55aa6bfb3e1605d60818.svg";
export { ForwardRef as ReactComponent };